import React, { useEffect, useRef } from 'react';
import { Paper, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import useStores from '../../stores/useStores';
import ProjectHeader from '../../components/project/ProjectHeader';
import BuildingDetails from '../../components/building/BuildingDetails';
import './Building.sass';
import '../../components/project/Details.sass';
import PageError from '../../components/errors/PageError';
import PanoramaToggleButton from '../../components/project/PanoramaToggleButton';
import ProjectHeaderPanorama from '../../components/project/ProjectHeaderPanorama';

const Building = ({
  isDemo = false,
  noHeaderMap,
  noHeader,
  history,
  match,
  style = {}
}) => {
  const detailsContainerRef = useRef();
  const { buildingId } = match.params;
  const {
    buildingDetailStore,
    projectDetailStore,
    mapStore,
    editorStore
  } = useStores();
  const { isLoading, building } = buildingDetailStore;

  useEffect(() => {
    (async () => {
      await buildingDetailStore.loadBuilding(buildingId);
    })();
  }, [buildingId]);

  const { polygon, address, centroid } = building || {};

  if (!isLoading && !building) {
    return (
      <PageError
        onClick={() => history.push('/search')}
        title="Property not found"
      />
    );
  }

  let description = '';
  if (building?.building_name) {
    description += ` ${building.building_name}`;
  }

  if (building?.property_type_short) {
    if (description.length > 0) {
      description += ` - ${building.property_type_short}`;
    } else {
      description += `${building.property_type_short}`;
    }
  }

  const buildingHeader = building && (
    <ProjectHeader
      noHeaderMap={noHeaderMap}
      mapStore={mapStore}
      editorStore={editorStore}
      showPanoramaToggle
      headerInfo={{
        name: address,
        description
      }}
      buildingId={buildingId}
      buildings={[
        {
          polygon,
          address,
          centroid: [centroid.lon, centroid.lat],
          id: buildingId
        }
      ]}
      variant={projectDetailStore.variant}
      history={history}
      onClick={() => {
        projectDetailStore.setVariant(
          projectDetailStore.variant === 'small' ? 'large' : 'small'
        );

        const element = document.querySelector('#details.building-details');
        const pointerEvents =
          projectDetailStore.variant === 'small' ? 'none' : 'all';

        if (element?.style) {
          element.style.pointerEvents = pointerEvents;
        }
      }}
    />
  );

  const views =
    projectDetailStore.variant === 'small'
      ? ['map', 'satellite']
      : ['map', 'panorama', 'satellite'];

  return (
    <Paper
      style={style}
      ref={detailsContainerRef}
      id="details"
      className={`building building-details project-details-${projectDetailStore.variant}`}
      elevation={0}
      square
    >
      {!noHeader && (
        <>
          <Button className="button-close" component={Link} to="/search/">
            Close
          </Button>
          <div className="header-map-toggle-wrapper" style={{ zIndex: 101 }}>
            <PanoramaToggleButton
              mapboxMapRef={mapStore.mapboxRef}
              views={views}
              gl={mapStore.gl}
              deckRef={mapStore.deckRef}
              viewState={editorStore.viewState}
              onChange={variant => {
                projectDetailStore.setHeaderVariant(variant);
              }}
            />
          </div>
          {projectDetailStore.headerVariant === 'panorama' && (
            <ProjectHeaderPanorama
              viewState={editorStore.viewState}
              onMouseOver={() => {
                const element = document.querySelector(
                  '#details.project-details'
                );
                if (element?.style) {
                  element.style.pointerEvents = 'none';
                }
              }}
              role="region"
            />
          )}
        </>
      )}

      <div
        style={{
          pointerEvents: projectDetailStore.variant === 'small' ? 'none' : 'all'
        }}
        className="details-container"
      >
        {buildingHeader}
        <BuildingDetails
          isDemo={isDemo}
          detailsContainerRef={detailsContainerRef}
          building={building}
          buildingId={buildingId}
        />
      </div>
    </Paper>
  );
};

export default observer(Building);
